import { chakra, Text, Flex } from '@chakra-ui/react';
import React from 'react';

import type { ItemsProps } from './types';
import type { SearchResultFragment } from 'types/api/search'; 
import * as TxEntity from 'ui/shared/entities/tx/TxEntity';
import HashStringShortenDynamic from 'ui/shared/HashStringShortenDynamic';

const SearchBarSuggestFragment = ({ data, isMobile }: ItemsProps<SearchResultFragment>) => {
  const icon = <TxEntity.Icon/>;
  const hash = (
    <chakra.mark overflow="hidden" whiteSpace="nowrap" fontWeight={ 700 }>
      <HashStringShortenDynamic hash={ data.fragment_hash } noTooltip/>
    </chakra.mark>
  ); 

  if (isMobile) {
    return (
      <>
        <Flex alignItems="center">
          { icon }
          { hash }
        </Flex>
        <Text color="text.secondary">{ data.block_number }</Text>
      </>
    );
  }

  return (
    <Flex columnGap={ 2 }>
      <Flex alignItems="center" minW={ 0 }>
        { icon }
        { hash }
      </Flex>
       <Text color="text.secondary" textAlign="end" flexShrink={ 0 } ml="auto">{ data.block_number }</Text>
    </Flex>
  );
};

export default React.memo(SearchBarSuggestFragment);
